import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";
import { ApiCommonParams } from "../../@types/apiTypes";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

export function indexStudents(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/tutors/students`, { params });
}
export function indexStudent(id: string | number): Promise<ApiResponse> {
  return Axios.get(`/v1/tutors/students/${id}`);
}
